import axios from "axios";
import { tokenHandler } from "./authStore";

export default async function refreshAccessToken(){
  const refreshToken = tokenHandler.get('refreshToken');

  if(!refreshToken) {
    throw new Error('Refresh token not found');
  }

  const {data} = await axios.post(`${process.env.REACT_APP_URL}/api/auth/refresh`, {refreshToken});

  if(!Object.hasOwn(data, 'accessToken')){
    throw new Error('Access token not found in response');
  }
  
  tokenHandler.set('accessToken', data.accessToken);

  if(Object.hasOwn(data, 'refreshToken')){
    tokenHandler.set('refreshToken', data.refreshToken);
  }

  return data;
}